import { render, staticRenderFns } from "./MaintenancePage.vue?vue&type=template&id=0050b262"
import script from "./MaintenancePage.vue?vue&type=script&lang=js"
export * from "./MaintenancePage.vue?vue&type=script&lang=js"
import style0 from "./MaintenancePage.vue?vue&type=style&index=0&id=0050b262&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports